import { createSelector } from "@ngrx/store";
import { ITimer } from "../../models/timer";
import { IAppState } from "../states/app";

export const selectTimerState = createSelector(
  (state: IAppState) => state.timer,
  (state: ITimer) => state,
);
